import { enumify, GameName } from "../messageTypes";

export type LobbyInfo = {
  game: GameName | null;
};

export namespace LobbyServer {
  const _Types = ["LOBBY_INFO"] as const;
  export const TypeValue = enumify("LobbyServer", _Types);
  export type Type = typeof TypeValue;

  export type LobbyInfoMessage = {
    type: Type["LOBBY_INFO"];
    data: LobbyInfo;
  };

  export type Message = LobbyInfoMessage;
}

export namespace LobbyClient {
  const _Types = ["SET_GAME", "START_GAME"] as const;
  export const TypeValue = enumify("LobbyClient", _Types);
  export type Type = typeof TypeValue;

  export type SetGameMessage = {
    type: Type["SET_GAME"];
    data: GameName;
  };

  export type StartGameMessage = {
    type: Type["START_GAME"];
    data: void;
  };

  export type Message = SetGameMessage | StartGameMessage;
}
